module.exports = __webpack_public_path__ + "img/thumbnail_PereDavidsDeer_m_normal.6597314a.png";